import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { addPayment } from "../../api/add";
import { AuthContext } from "../../context/auth-context";
import { DataContext } from "../../context/data-context";
import LoadingSpinner from "../UI/LoadingSpinner";


export default function PaymentForm({
  selectedCustomer,
  bookingId,
  amount,
  description,
}) {
  const { user } = useContext(AuthContext);
  const { customers, refreshData } = useContext(DataContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState(false);
  const [type, setType] = useState("payment");

  const [customer, setCustomer] = useState(selectedCustomer || customers[0]);

  const selectCustomer = (e) => {
    setCustomer(
      customers.filter((customer) => customer.id === e.target.value)[0]
    );
  };

  const submitHandler = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const payload = {
        customerId: customer.id,
        amount: parseFloat(e.target.amount.value).toFixed(2),
        type: e.target.charge.value,
        description: e.target.description.value,
      };

      if (payload.amount <= 0) {
        setLoading(false);
        return;
      }

      if (e.target.charge.value === "payment") {
        payload.payment_method_id = e.target.payment_method_id.value;
      }
      if (e.target.charge.value === "invoice") {
        payload.days_until_due = e.target.days_until_due.value;
      }
      if (e.target.booking.value !== "") {
        payload.bookingId = e.target.booking.value;
      }

      await addPayment(user, payload);

      refreshData(navigate("/payments"));
      setLoading(false);
    } catch (err) {
      console.log(err);
      setWarning(err.message);
      setLoading(false);
    }
  };
  return (
    <form onSubmit={submitHandler} className="grid gap-8">
      <div className="grid text-sm md:grid-cols-4 md:gap-x-8 md:gap-y-4 text-stone-400">
        <div className="grid">
          <label className="text-sm">CUSTOMER:</label>
          <select
            className="form-input"
            name="customer"
            defaultValue={customer?.id || customers[0].id}
            onChange={selectCustomer}
            disabled={selectedCustomer ? true : false}
          >
            {customers.map((customer) => (
              <option value={customer.id} key={customer.id}>
                {customer.firstName} {customer.lastName}
              </option>
            ))}
          </select>
        </div>
        <div className="grid">
          <label className="text-sm">CHARGE:</label>
          <select
            onChange={(e) => setType(e.target.value)}
            className="form-input"
            name="charge"
          >
            <option value="payment">Now</option>
            <option value="invoice">Send Invoice</option>
          </select>
        </div>
        {type == "payment" && (
          <div className="grid">
            <label className="text-sm">PAYMENT METHOD:</label>
            {customer?.default_payment_method ? (
              <select className="form-input" name="payment_method_id">
                <option value={customer.default_payment_method.id}>
                  {customer.default_payment_method.brand}{" "}
                  {customer.default_payment_method.last4}
                </option>
                {customer.payment_methods &&
                  customer.payment_methods.map((pm) => (
                    <option value={pm.id}>
                      {pm.brand} {pm.last4}
                    </option>
                  ))}
              </select>
            ) : (
              <input
                className="form-input-disabled"
                name="payment_method_id"
                placeholder="No Payment Methods Attached"
                disabled
              />
            )}
          </div>
        )}
        {type == "invoice" && (
          <div className="grid">
            <label className="text-sm">DAYS UNTIL DUE:</label>
            <input
              type="number"
              name="days_until_due"
              className="form-input"
              required
            />
          </div>
        )}
        <div className="grid">
          <label className="text-sm">ASSOCIATED BOOKING ID:</label>
          <input
            className="form-input"
            name="booking"
            defaultValue={bookingId || ""}
            placeholder="Cannot be left blank"
            required
          />
        </div>
        <div className="grid">
          <label className="text-sm">AMOUNT:</label>
          <input className="form-input" name="amount" defaultValue={amount} />
        </div>
        <div className="grid md:col-span-3">
          <label className="text-sm">DESCRIPTION:</label>
          <input
            className="form-input"
            name="description"
            defaultValue={description || ""}
            placeholder="Description"
            required
          />
        </div>
      </div>

      <div className="flex items-center space-x-4">
        {loading ? (
          <div className="btn-loading">
            <LoadingSpinner classes="w-6 h-6 text-white" />
          </div>
        ) : (
          <button type="submit" className="btn-primary">
            Charge Customer
          </button>
        )}
        {warning && (
          <p className="text-sm text-red-600 md:col-span-3">{warning}</p>
        )}
      </div>
    </form>
  );
}
